import { source_consumption_enum } from '@predium/enums';
import { Trans, getI18n } from 'react-i18next';

export const translateSourceConsumptionEnum = (enumValue: source_consumption_enum) => {
  switch (enumValue) {
    case source_consumption_enum.ESTIMATION:
      return <Trans i18nKey="Enum_SourceConsumptionEnum-ESTIMATION" />;
    case source_consumption_enum.INVOICE:
      return <Trans i18nKey="Enum_SourceConsumptionEnum-INVOICE" />;
    case source_consumption_enum.MANUAL_ENTRY:
      return <Trans i18nKey="Enum_SourceConsumptionEnum-MANUAL_ENTRY" />;
    case source_consumption_enum.SMART_METER:
      return <Trans i18nKey="Enum_SourceConsumptionEnum-SMART_METER" />;
  }
};

export const translateSourceConsumptionEnum_dynamic = (enumValue: source_consumption_enum) => {
  const t = getI18n().t;
  switch (enumValue) {
    case source_consumption_enum.ESTIMATION:
      return t('Enum_SourceConsumptionEnum-ESTIMATION');
    case source_consumption_enum.INVOICE:
      return t('Enum_SourceConsumptionEnum-INVOICE');
    case source_consumption_enum.MANUAL_ENTRY:
      return t('Enum_SourceConsumptionEnum-MANUAL_ENTRY');
    case source_consumption_enum.SMART_METER:
      return t('Enum_SourceConsumptionEnum-SMART_METER');
  }
};
